const locale = {
  'shoppingCart.title.shoppingCart': 'Shopping Cart',
  'shoppingCart.text.total': 'Total:',
  'shoppingCart.text.totalContent': '{total} SKUs, total {totalCount} items',
  'shoppingCart.button.deleteCommodity': 'Delete products',
  'shoppingCart.modal.deleteCommodity': `Are you sure to delete the selected product`,
  'shoppingCart.button.clearQuantity': 'Reset quantity',
  'shoppingCart.modal.clearQuantity': 'Are you sure to reset the quantity of selected items?',
  'shoppingCart.button.exportSelected': 'Export Selected',
  'shoppingCart.notification.export.message': 'Selected items have been exported',
  'shoppingCart.notification.export.description': 'Check your browser downloads',
  'shoppingCart.import.rule1': '1. Only xlsx files are supported for import',
  'shoppingCart.import.rule2':
    '2. You can refer to the table below for the updatable list. Columns marked with * are required',
  'shoppingCart.import.rule3':
    '3. After confirmation, the quantity of existing part numbers will be updated',
  'shoppingCart.button.batchUpdateQuantity': 'Batch Update Quantity',
  'shoppingCart.message.emptyCart': 'The shopping cart is empty, batch update is not allowed.',
  'shoppingCart.message.emptyUpdateData': 'No data to update, batch update is not allowed.',
  'shoppingCart.import.partNumber': 'Part Number',
  'shoppingCart.import.brand': 'Brand',
  'shoppingCart.import.quantity': 'Quantity',
  'shoppingCart.message.invalidCheckedCartItems':
    'Some commodity quantities do not meet the requirements, please check',
  'shoppingCart.message.differentStoreCartItems':
    'You can only place an order from one store at a time',
};

export default locale;
